import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { Button, IconButton, Typography, TextField, Autocomplete , OutlinedInput } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useCreateAreaMutation } from '../../Store/Services/AreaService';
import { useGetAllStatesQuery } from '../../Store/Services/StateService';
import styles from './AddArea.module.css';


const schema = yup.object({
  state: yup.object().required('State is required'),
  desc: yup.string().required('Area  is required')
});

const AddArea = ({ handleClose }) => {
  const { control, handleSubmit,  register, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(schema)
  });
  const { data: states, isLoading } = useGetAllStatesQuery();
  const [addArea] = useCreateAreaMutation();

  const submit = async (data) => {
    try {
      await addArea({
        stateId: data.state.stateId, 
        desc: data.desc
      }).unwrap();
      toast.success('Area added successfully!', { position: 'bottom-right' });
      handleClose();
    } catch (err) {
      console.error(err);
      toast.error('Error, Something went wrong', { position: 'bottom-right' });
    }
  };

  return (
    <div className={styles.addCouponContainer}>
      <div className={styles.headingContainer}>
        <Typography fontWeight={600} className={styles.dialogTitle} variant="h6">
          Add Area
        </Typography>
        <IconButton className={styles.closeButton} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </div>

      <form onSubmit={handleSubmit(submit)} autoComplete="off">
        <div className={styles.formItem}>
        <label className={styles.formLabel}> State :</label>
        {errors.state && <span className={styles.validation}> *</span>}
          <Controller
            name="state"
            control={control}
            render={({ field }) => (
              <Autocomplete
                {...field}
                {...register("state")}
                options={states || []}
                getOptionLabel={(option) => option.state || ''}
                loading={isLoading}
                onChange={(_, selectedState) => {
                  setValue('state', selectedState, { shouldValidate: true });
                }}
                renderInput={(params) => (
                  <TextField 
                    {...params}
                    placeholder='Select State'
                    size="small"
                    className={styles.formInput}
                    fullWidth
                  />
                )}
              />
            )}
          />
        </div>

        <div className={styles.formItem}>
        <label className={styles.formLabel}> Area :</label>
        {errors.desc && <span className={styles.validation}> *</span>}
          <TextField
            {...register("desc")}
            size="small"
            className={styles.formInput}
            placeholder='Enter Area'
            fullWidth
          />
        </div>

        <div className={styles.buttonContainer}>
          <Button type="submit" className={styles.submitButton} variant="contained">
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddArea;
